import { render, staticRenderFns } from "./ModalColorimetro.vue?vue&type=template&id=da049be6&scoped=true"
import script from "./ModalColorimetro.vue?vue&type=script&lang=js"
export * from "./ModalColorimetro.vue?vue&type=script&lang=js"
import style0 from "./ModalColorimetro.vue?vue&type=style&index=0&id=da049be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da049be6",
  null
  
)

export default component.exports